<template>
  <div class="c-header-menu-item-mobile">
    <component
      :is="htmlTag"
      class="c-header-menu-item-mobile__main"
      :style="styleLevel"
      v-bind="attributes"
      @click="onClick"
    >
      <i
        v-if="menuItem.iconName"
        :class="['c-header-menu-item-mobile__icon', menuItem.iconName]"
      ></i>
      <img
        v-else-if="showImage && menuItem.image"
        class="c-header-menu-item-mobile__image"
        :src="menuItem.image"
      />
      <span v-else class="c-header-menu-item-mobile__image"></span>
      <h3 class="c-header-menu-item-mobile__title">
        {{ menuItem.title }}
      </h3>

      <span
        v-if="menuItem.items.length"
        class="c-header-menu-item-mobile__plus"
      >
        <span
          :class="['c-header-menu-item-mobile__vertical', { isAccordionOpen }]"
        ></span>
        <span class="c-header-menu-item-mobile__horizontal"></span>
      </span>
    </component>

    <template v-if="menuItem.items.length">
      <ul
        :class="['c-header-menu-item-mobile__children', { isAccordionOpen }]"
        :style="styleChildrenHeight"
      >
        <li
          v-for="childItem in menuItem.items"
          :key="childItem.url"
          ref="children"
        >
          <menu-item-mobile
            :level="level + 1"
            :menu-item="childItem"
            :show-image="childrenShowImage"
            @children-height-changed="onChildrenHeightChanged"
          ></menu-item-mobile>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import MenuItemMobile from '~/js/components/header/menuItemMobile'

export default {
  name: 'ComponentHeaderMenuItemMobile',
  props: {
    level: { type: Number, default: 1 },
    menuItem: {
      type: Object,
      default: () => {
        return {}
      },
    },
    showImage: { type: Boolean, default: false },
  },
  components: {
    MenuItemMobile,
  },
  computed: {
    attributes() {
      return this.menuItem.items.length
        ? { type: 'button' }
        : { href: this.menuItem.url }
    },
    childrenShowImage() {
      return this.menuItem.items.some((item) => !!item.image)
    },
    htmlTag() {
      return this.menuItem.items.length ? 'button' : 'a'
    },
    styleChildrenHeight() {
      return {
        height: this.isAccordionOpen ? `${this.childrenHeight}px` : 0,
      }
    },
    styleLevel() {
      return { paddingLeft: `${this.level * 28}px` }
    },
  },
  data() {
    return {
      childrenHeight: 0,
      isAccordionOpen: false,
    }
  },
  methods: {
    onClick() {
      if (!this.$refs.children) return

      this.isAccordionOpen = !this.isAccordionOpen
      this.childrenHeight = this.$refs.children.reduce((sum, element) => {
        return sum + element.clientHeight
      }, 0)
      const delta = this.isAccordionOpen
        ? this.childrenHeight
        : -1 * this.childrenHeight
      this.$emit('children-height-changed', { delta })
    },
    onChildrenHeightChanged({ delta }) {
      this.childrenHeight += delta
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';

.c-header-menu-item-mobile {
  &__main {
    align-items: center;
    background-color: #fff;
    border-bottom: 1px solid variables.$color-gray;
    display: flex;
    height: 48px;
    justify-content: space-between;
    padding-right: 16px;
    width: 100%;
  }

  &__icon {
    font-size: 20px;
    margin-right: 4px;
  }

  &__image {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    object-fit: contain;
  }

  &__title {
    flex-grow: 1;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
  }

  &__children {
    transition: 0.3s;
    overflow: hidden;
  }

  &__plus {
    width: 9px;
    height: 9px;
    position: relative;
    margin-left: 8px;
  }

  &__vertical,
  &__horizontal {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 9px;
    height: 1px;
    background-color: variables.$color-text;
  }

  &__vertical {
    transition: 0.3s;
    transform: rotate(90deg);

    &.isAccordionOpen {
      opacity: 0;
      transform: rotate(0deg);
    }
  }
}
</style>
